import {
  Alert,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Zoom,
} from "@mui/material";
import { useState } from "react";
import { ReactComponent as DeleteSVG } from "../../assets/delete.svg";
import { docs_enum } from "../../utils/helpers";
import { ReactComponent as AttachmentAvatar } from "../../assets/attacchment.svg";
import { Input } from "antd";
import { postFeedBack } from "../../actions/user";
import { connect } from "react-redux";
const { TextArea } = Input;

export default connect(({ userProfile }) => ({ userProfile }), {
  postFeedBack,
})((props) => {
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const [target, setTarget] = useState();

  const [file, setFile] = useState();

  const [alertOpen, setAlertOpen] = useState(false);


  //   const handleFileChange = (e) => {
  //     let file = e.target.files[0];
  //     // if (file.name.includes(".")) {
  //     //     setAlertText("Invalid File Extension !");
  //     // }
  //     setTarget(e);
  //     setFile(file);
  //     // if (props.customFileChange) {
  //     //   props.customFileChange(e);
  //     // }
  //   };

  //   const deleteFile = () => {
  //     setTarget();
  //     setFile();
  //   };

  //   const renderFileDetails = () => {
  //     return (
  //       <div className="fileDetails">
  //         <div className="detail">
  //           <div className="name"> {formatfileName(file?.name, 30)}</div>
  //           <div className="size"> {file.size / 1000} KB</div>
  //         </div>
  //         <div className="icon">
  //           <DeleteSVG onClick={deleteFile} />
  //         </div>
  //       </div>
  //     );
  //   };

  //   const formatfileName = (str, limit) => {
  //     let name = str?.split(".");
  //     if (name?.length > 1) {
  //       if (name[0].length > limit) {
  //         return name[0]?.substr(0, limit) + "... ." + name[name.length - 1]; // name upto limit character + extention
  //       } else {
  //         return name[0]?.substr(0, limit) + "." + name[name.length - 1];
  //       }
  //     } else {
  //       return name[0]?.substr(0, limit);
  //     }
  //   };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const submitFeedback = () => {
    const clientName =
      props?.userProfile?.user?.ismemberof?.[0]?.legalentity?.name || "";
    const givenName = props?.userProfile?.user?.givenname || "";
    const surName = props?.userProfile?.user?.surname || "";
    const fullName = `${givenName} ${surName}`.trim();

    setAlertOpen(true);
    
    props.postFeedBack({
      subject: type,
      body: description,
      client: clientName,
      user: fullName,
    });

    setType("");
    setDescription("");
    setTimeout(()=>{
        setAlertOpen(false);
    },4000)
  }

  return (
    <div className="_content" style={{ padding: "25px" }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertOpen}
        onClose={handleClose}
        TransitionComponent={Zoom}
      >
        <Alert severity={"success"} sx={{ width: "100%" }} className="bxShadow">
          <div className="primary"><b>Nachricht gesendet</b></div>
          <div className="secondary">
            Vielen Dank! Wir bearbeiten Ihr Anliegen so bald wie möglich.
          </div>
        </Alert>
      </Snackbar>

      <div className="_header">
        <div className="_title"> Feedback hinterlassen</div>
      </div>

      <div style={{ width: "77%" }}>
        <FormControl fullWidth style={{ margin: "10px 0px 36px 0px" }}>
          <InputLabel id="demo-simple-select-label_helpandfeed">
            Typ der Meldung
          </InputLabel>
          <Select
            labelId="demo-simple-select-label_helpandfeed"
            id="demo-simple-select_helpandfeed"
            value={type}
            label="Typ der Meldung"
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            <MenuItem value={"Generelles Feedback"}>
              Generelles Feedback
            </MenuItem>
            <MenuItem value={"Probleme beim Einrichten"}>
              Probleme beim Einrichten
            </MenuItem>
            <MenuItem value={"Probleme beim Betrieb"}>
              Probleme beim Betrieb
            </MenuItem>

            <MenuItem value={"Funktionalität und Features"}>
              Funktionalität und Features
            </MenuItem>
            <MenuItem value={"Sonstiges"}>Sonstiges</MenuItem>
          </Select>

          <TextArea
            rows={4}
            placeholder="Ihre Nachricht an uns..."
            style={{ margin: "36px 0px" }}
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />

          {/* <div style={{ margin: "0px 0px 36px 0px" }}>
            <input
              id="myInputDoc"
              style={{ display: "none" }}
              type={"file"}
              accept={docs_enum}
              onChange={handleFileChange}
            />
            <Card
              sx={{
                height: 56,
                width: 328,
              }}
              variant="outlined"
              style={{ marginBottom: 5, borderColor: "#00000020" }}
            >
              <CardActionArea>
                {file ? (
                  renderFileDetails()
                ) : (
                  <label htmlFor="myInputDoc">
                    <CardHeader
                      sx={{
                        height: 56,
                        cursor: "pointer",
                      }}
                      className="NT_cardHeader"
                      avatar={
                        <Icon color="primary" className={""}>
                          <AttachmentAvatar />
                        </Icon>
                      }
                      title={"Anhänge hinzufügen"}
                    />
                  </label>
                )}
              </CardActionArea>
            </Card>
          </div> */}

          <Button
            variant="contained"
            disabled={type === "" || description === ""}
            sx={{ width: "194px" }}
            onClick={submitFeedback}
          >
            {"Feedback absenden"}
          </Button>
        </FormControl>
      </div>
    </div>
  );
});
